const conversionBoxInstantSearchScript = `
var conversionBoxInstantSearch = {
	loopProducts: async(aiResultListWrap, val, i, page) => {
		let roundViewInstantSearch  = window.roundViewInstantSearch, 
			aiResultListItem = document.createElement("li"),
			valDocument	= val.document,
			productData = { id: valDocument.id, name: valDocument.name, image: valDocument.image, maxPrice: valDocument.maxPrice, url: valDocument.url, variants: valDocument.variants }
		aiResultListItem.classList.add("rvsResultListItem")
		aiResultListItem.setAttribute("data-product-id", valDocument.id)
		aiResultListItem.innerHTML	= \`
														<a href="\${valDocument.url}" class="rvSRProductLink" draggable="false" onclick="window.roundViewInstantSearch.productClickEvent(event, \${JSON.stringify(productData).replace(/"/g, '&quot;')})">
															<div class="rvSRItem">
																<div class="rvSRThumnailWrapper">
																	<span class="rvSRThumbnail">
																		<img src="\${valDocument.image ? valDocument.image : "https://storage.googleapis.com/roundclicksview/No%20Product%20Image%20Available.png"}" class="rvSRItemImage " alt="" border="0" loading="lazy">
																		\`+roundViewInstantSearch.getFlipImage(valDocument)+\`
																	</span>
																</div>
																<span class="rvSROverHidden">
																	<span class="rvSRTitle" style="-webkit-line-clamp: \${( roundViewInstantSearch.instantSearchConfig && roundViewInstantSearch.instantSearchConfig.titleMaxLines ) ? roundViewInstantSearch.instantSearchConfig.titleMaxLines : 2 };">\${valDocument.name}</span>
																	\${( ( roundViewInstantSearch.instantSearchConfig && roundViewInstantSearch.instantSearchConfig.showVendor ) && valDocument.brand ) ?
																		\`<span class="rvSRBrand">By \${valDocument.brand}</span>\`
																	:
																		""
																	}
																	\${( roundViewInstantSearch.instantSearchConfig && roundViewInstantSearch.instantSearchConfig.showDescription && valDocument.description ) ?
																		\`<span class="rvSRDescription" style="-webkit-line-clamp: \${roundViewInstantSearch.instantSearchConfig.titleMaxLines};">\${valDocument.description}</span>\`
																	:
																		""
																	}
																	\${( roundViewInstantSearch.instantSearchConfig && roundViewInstantSearch.instantSearchConfig.showSKU && valDocument.sku ) ? \`<div class="rvSRSKU">\${valDocument.sku}</div>\`: ""}
																	\${ roundViewInstantSearch.instantSearchConfig && ( typeof roundViewInstantSearch.instantSearchConfig.showPrice === "undefined" || roundViewInstantSearch.instantSearchConfig.showPrice ) ?
																		\`<div class="rvSRPriceList">
																			<span class="rvSRPrice">\`+roundViewInstantSearch.formatPrice(valDocument)+\`</span>
																		</div>\`
																	:
																		""
																	}
																	\${(roundViewInstantSearch.instantSearchConfig && roundViewInstantSearch.instantSearchConfig.enableQuickPreview) ?
																		\`<button class="rvSRButton rvSRActionButton rvSRQuickPreview" onClick="window.roundViewInstantSearch.openQuickPreview(event, \${i}, \${page})">Quick Preview</button>\`
																	:
																		""
																	}
																	<button class="rvSRButton rvSRActionButton rvSRAddToCartButton" onClick="window.roundViewInstantSearch.addToCart(event, \${JSON.stringify({ ...productData }).replace(/"/g, '&quot;')})">Add to cart</button>
																</span>
															</div>
														</a>
													\`
			aiResultListWrap.appendChild(aiResultListItem)
	},
};
`;

export default conversionBoxInstantSearchScript;